// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"37a034ad","455":"a58f6621","488":"c3ce8fe4","977":"5696b06c"}[chunkId] + ".chunk.js";
};